import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import * as signalR from "@microsoft/signalr";
import { LogLevel, HttpTransportType } from "@microsoft/signalr";
import { useSnackbar } from 'notistack';
import { GridRenderCellParams, GridCellEditStopReasons, GridCellEditStopParams, GridValueFormatter} from "@mui/x-data-grid";
import { DataGridPro, GridColDef, GridColumnOrderChangeParams, GridPaginationModel, GridRowParams, GridRowId, GridColumnVisibilityModel } from "@mui/x-data-grid-pro";

import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Checkbox,
    FormControlLabel,
    Typography,
    Autocomplete
    //Box,
} from "@mui/material";
//import { GridFilterInputDate } from "@mui/x-data-grid/components/panel/filterPanel/GridFilterInputDate";

import { GridSortModel, GridFilterModel } from "@mui/x-data-grid";
import { enUS, deDE, plPL, roRO } from '@mui/x-data-grid/locales';

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WorkIcon from "@mui/icons-material/Work";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";

//import dayjs from 'dayjs';
//import { format }  from "date-fns";
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/pl';
import 'dayjs/locale/ro';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/zh-cn';
//import { DatePicker } from "@mui/x-date-pickers"; 
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useTranslation } from "react-i18next";

const locales = ['en', 'en-gb', 'zh-cn', 'de', 'pl', 'ro'];
type LocaleKey = (typeof locales)[number];

import axiosExt from '../axios';
import axios from "axios";
import { Order, Customer, User, OrderState, Service, OrderService } from "../types";
import { PRIORITY_ORDER, ORDER_PRIORITIES, OrderPriority } from "../types";

import { API_BASE_URL } from "../config.ts";
import type { EditableOrderField } from "../types/index"; // adjust path



//import { LicenseInfo } from '@mui/x-license-pro';
//LicenseInfo.setLicenseKey('b1a2b5992264fefb50983aca320ec56cTz0xMDkzNDgsRT0xNzczMTAwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

interface Props {
    orders: Order[];
    users: User[];
    services: Service[];
    orderStates: OrderState[];
    customers: Customer[];
    onSaveOrder: (order: Order) => Promise<void>;
    onDeleteOrder: (id: string) => void;
    onFieldValueSelected: (field: EditableOrderField, value: string) => void;
}

const OrderTableServerFiltering: React.FC<Props> = ({ orders, users, services, orderStates, customers, onSaveOrder, onDeleteOrder }) => {
    const navigate = useNavigate();
    const [locale, setLocale] = React.useState<LocaleKey>('de');
    const { t } = useTranslation();

    //const [orders, setOrders] = useState<Order[]>([]);
    //const [customers, setCustomers] = useState<Customer[]>([]);
    const [loading, setLoading] = useState<Record<string, boolean>>({});
    const [open, setOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);

    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState<string | null>(null);

    //const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(0);

    const [sortModel, setSortModel] = useState<GridSortModel>([]);
    const [filterModel, setFilterModel] = useState<GridFilterModel>({ items: [] });
    //const [users, setUsers] = useState<User[]>([]);
    //const [orderTypes, setOrderTypes] = useState<OrderType[]>([]);
    //const [orderStates, setOrderStates] = useState<OrderState[]>([]);
    //const [services, setServices] = useState<Service[]>([]);

    const [selectionModel, setSelectionModel] = useState<GridRowId[]>([]);

    const hiddenColsKey = "hiddenOrderColumns";
    const [columnVisibilityModel, setColumnVisibilityModel] = useState<GridColumnVisibilityModel>(() => {
        try {
            const saved = localStorage.getItem(hiddenColsKey);
            return saved ? JSON.parse(saved) : {};
        } catch {
            return {};
        }
    });
    // ✅ Track Previous Values to Avoid Redundant Calls
    const prevPage = useRef<number | null>(null);
    const prevPageSize = useRef<number | null>(null);
    const prevSortModel = useRef<GridSortModel | null>(null);
    const prevFilterModel = useRef<GridFilterModel | null>(null);

    const pageSizeKey = "orderTablePageSize";
    const savedPageSize = parseInt(localStorage.getItem(pageSizeKey) || "10", 10);
    const [pageSize, setPageSize] = useState(savedPageSize);

    const localeMap: Record<string, any> = {
        en: enUS.components.MuiDataGrid.defaultProps.localeText,
        de: deDE.components.MuiDataGrid.defaultProps.localeText,
        pl: plPL.components.MuiDataGrid.defaultProps.localeText,
        ro: roRO.components.MuiDataGrid.defaultProps.localeText,
    };

    const savedColumnWidthsKey = "orderTableColumnWidths";

    const [servicesPopupOpen, setServicesPopupOpen] = useState(false);
    const [popupOrderServices, setPopupOrderServices] = useState<OrderService[]>([]);
    const [popupOrderId, setPopupOrderId] = useState<string | null>(null);

    const copyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text).then(() => {
            console.log("Copied to clipboard:", text);
        }).catch(err => {
            console.error("Failed to copy:", err);
        });
    };

    const formatPriority: GridValueFormatter = (value) => {
        const v = value as OrderPriority | null | undefined;
        return v ? t(v) : "";
    };

    const handleOpenServicesPopup = async (order: Order) => {
        try {
            const orderId = order.id;
            if (!orderId) return;

            // Fetch order services for this order
            const token = localStorage.getItem("token");
            const response = await axiosExt.get(`${API_BASE_URL}/orders/${orderId}/services`, {
                headers: { Authorization: `Bearer ${token}` }, // if needed
            });

            const orderServices: OrderService[] = response.data;
            //const serviceIds = orderServices.map(os => os.serviceId);
            //const matchedServices = services.filter(s => s.id && serviceIds.includes(s.id));

            
            //setPopupOrderServices(matchedServices);
            setPopupOrderServices(orderServices);
            setPopupOrderId(order.internalNumber || order.id || null);
            setServicesPopupOpen(true);
        } catch (error) {
            console.error("Failed to load order services", error);
            setPopupOrderServices([]); // ensure UI doesn't crash
            setPopupOrderId(order.internalNumber || order.id || null);
            setServicesPopupOpen(true);

        }
    };

    const handleCloseServicesPopup = () => {
        setServicesPopupOpen(false);
        setPopupOrderServices([]);
        setPopupOrderId(null);
    };

    const formatDate: GridValueFormatter = (value : string) => {
        if (!value || typeof value !== "string") return "";

        // Ensure the timestamp is treated as UTC
        const isoString = value.endsWith("Z") ? value : `${value}Z`;
        const date = new Date(isoString);

        if (isNaN(date.getTime())) return "";

        const dateLocal = new Intl.DateTimeFormat(undefined, {
            dateStyle: "medium",
            timeStyle: "short",
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }).format(date);

        return dateLocal;
    };

    //const fetchServices = async () => {
    //    try {
    //        const token = localStorage.getItem("token");
    //        const response = await axiosExt.get<Service[]>(`${API_BASE_URL}/services`, {
    //            headers: { "Authorization": `Bearer ${token}` },
    //        });
    //        setServices(response.data);
    //    } catch (error) {
    //        console.error("Error fetching services:", error);
    //    }
    //};

    //const fetchOrderTypes = async () => {
    //    setLoading((prev) => ({ ...prev, global: true }));

    //    try {
    //        const token = localStorage.getItem("token");
    //        const response = await axiosExt.get<OrderType[]>(`${API_BASE_URL}/orderTypes/`, {
    //            method: "GET",
    //            headers: {
    //                "Content-Type": "application/json",
    //                "Authorization": `Bearer ${token}`,
    //            },
    //        }
    //        );
    //        if (response.status === 401) {
    //            throw new Error("Unauthorized. Please log in again.");
    //        }

    //        setOrderTypes(response.data);
    //    } catch (error) {
    //        console.error("Error fetching orderTypes:", error);
    //    } finally {
    //        setLoading((prev) => ({ ...prev, global: false }));
    //    }
    //}

    //const fetchOrderStates = async () => {
    //    setLoading((prev) => ({ ...prev, global: true }));

    //    try {
    //        const token = localStorage.getItem("token");
    //        const response = await axiosExt.get<OrderState[]>(`${API_BASE_URL}/orderStates/`, {
    //            method: "GET",
    //            headers: {
    //                "Content-Type": "application/json",
    //                "Authorization": `Bearer ${token}`,
    //            },
    //        }
    //        );
    //        if (response.status === 401) {
    //            throw new Error("Unauthorized. Please log in again.");
    //        }

    //        setOrderStates(response.data);
    //    } catch (error) {
    //        console.error("Error fetching order states:", error);
    //    } finally {
    //        setLoading((prev) => ({ ...prev, global: false }));
    //    }
    //}

    //const fetchUsers = async () => {
    //    setLoading((prev) => ({ ...prev, global: true }));

    //    try {
    //        const token = localStorage.getItem("token");
    //        const response = await axiosExt.get<User[]>(`${API_BASE_URL}/users/roles/admin-support`, {
    //            method: "GET",
    //            headers: {
    //                "Content-Type": "application/json",
    //                "Authorization": `Bearer ${token}`,
    //            },
    //        }
    //        );
    //        if (response.status === 401) {
    //            throw new Error("Unauthorized. Please log in again.");
    //        }
    //        console.log("1 Setting users to:", response.data);
    //        setUsers(response.data);
    //    } catch (error) {
    //        console.error("Error fetching users:", error);
    //    } finally {
    //        setLoading((prev) => ({ ...prev, global: false }));
    //        //console.error(users.length);
    //    }
    //}

    /*const fetchOrders = async () => {
        setLoading(true);
        try {
            const response = await axiosExt.get("https://localhost:5001/api/orders", {
                params: {
                    page,
                    pageSize,
                    sortField,
                    sortOrder,
                    filterField,
                    filterValue,
                },
            });

            setOrders(response.data.data);
            setTotalRows(response.data.totalRecords);
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
        setLoading(false);
    };*/

    //const fetchCustomers = async () => {
    //    const token = localStorage.getItem("token");

    //    try {
    //        const response = await axiosExt.get<Customer[]>(`${API_BASE_URL}/customers`, {
    //            method: "GET",
    //            headers: {
    //                "Content-Type": "application/json",
    //                "Authorization": `Bearer ${token}`,
    //            },
    //        }

    //        );

    //        if (response.status === 401) {
    //            throw new Error("Unauthorized. Please log in again.");
    //        }

    //        const sortedCustomers = [...response.data].sort((a, b) =>
    //            a.name.localeCompare(b.name)
    //        );

    //        setCustomers(sortedCustomers);
    //    } catch (error) {
    //        console.error("Error fetching customers:", error);
    //    }
    //};

    const handleColumnResize = useCallback((params: { colDef: GridColDef; width: number }) => {
        const { colDef, width } = params;
        const savedWidths = JSON.parse(localStorage.getItem(savedColumnWidthsKey) || "{}");
        savedWidths[colDef.field] = width;
        localStorage.setItem(savedColumnWidthsKey, JSON.stringify(savedWidths));
    }, []);


    //function sanitizeOrderPayload(order: Order): Order {
    //    return {
    //        ...order,
    //        orderServices: (order.orderServices ?? []).map(os => ({
    //            serviceId: os.serviceId,
    //            orderId: order.id,
    //        })),

    //        orderDetails: [], // remove if not relevant
    //    };
    //}
    // Base columns do lookups referencing the latest users, orders, etc.
    const baseColumns = useMemo<GridColDef[]>(() => {
        return [
            {
                field: "action_edit",
                headerName: t("Edit"),
                width: 40,
                minWidth: 40,
                sortable: false,
                filterable:false,
                renderCell: (params: GridRenderCellParams) => (
                    <>
                        <Button
                            variant="contained"
                            onClick={(e) => {
                                e.stopPropagation(); // prevent row click/select to change background
                                handleEdit(params.row as Order);
                            }}
                            style={{ minWidth: 30, width: 30, padding: 0, margin: 0 }}
                            size="small"
                        >
                            <EditIcon />
                        </Button>
                    </>
                ),
            },
            {
                field: "action_details",
                headerName: t("Details"),
                width: 40,
                minWidth: 40,
                sortable: false,
                filterable: false,
                renderCell: (params: GridRenderCellParams) => (
                    <>
                        <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/orderdetailspage/${params.row.id}`)
                            }}
                            style={{ minWidth: 30, width: 30, padding: 0, margin: 0 }}
                        >
                            <VisibilityIcon />
                        </Button>
                    </>

                ),
            },
            {
                field: "action_service",
                headerName: t("Services"),
                width: 40,
                minWidth: 40,
                sortable: false,
                filterable: false,
                renderCell: (params: GridRenderCellParams) => (
                    <>
                        < Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleOpenServicesPopup(params.row);
                            }}
                            style={{ minWidth: 30, width: 30, padding: 0, margin: 0 }}
                        >
                            <WorkIcon />
                        </Button>
                    </>
                ),
            },
            {
                field: "action_delete",
                headerName: t("Delete"),
                width: 40,
                minWidth: 40,
                sortable: false,
                filterable: false,
                renderCell: (params: GridRenderCellParams) => (
                    <>
                        < Button
                            variant="contained"
                            color="error"
                            size="small"
                            style={{ minWidth: 30, width: 30, padding: 0, margin: 0 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(params.row.id)
                            }}
                        >
                            <DeleteIcon />
                        </Button>
                    </>

                ),
            },
            {
                field: "hasUnreadEmails",
                headerName: t("New Email"),
                width: 80,
                align: "center",
                headerAlign: "center",
                sortable: true,
                renderCell: (params) => params.value ? <MailOutlineIcon color="primary" /> : null,
            },
            {
                field: "lastEmailReceivedAt",
                headerName: t("Last Email Received At"),
                type: "dateTime",
                width: 180,
                valueGetter: (_, row) => {
                    return `${row.lastEmailReceivedAt || ''}`;
                },

                // ✅ Format the Date object safely
                valueFormatter: formatDate,

                renderCell: (params) => {
                    if (!params.value || typeof params.value !== "string") return "";

                    // Add 'Z' if missing to force UTC interpretation
                    const isoString = params.value.endsWith("Z") ? params.value : `${params.value}Z`;
                    const date = new Date(isoString);
                    if (isNaN(date.getTime())) return "";

                    const dateLocal = new Intl.DateTimeFormat(undefined, {
                        dateStyle: "medium",
                        timeStyle: "short",
                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    }).format(date);

                    return dateLocal;
                }

            },
            /*{ field: "internalNumber", headerName: t("Internal Number"), width: 100 },*/
            {
                field: "internalNumber",
                headerName: t("Internal Number"),
                width: 130,
                renderCell: (params: GridRenderCellParams) => (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>{params.value}</span>
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation(); // prevent row navigation
                                if (params.value) //copyToClipboard(params.value);
                                    navigator.clipboard.writeText(params.value)
                            }}
                        >
                            <ContentCopyIcon fontSize="small" />
                        </IconButton>
                    </Box>
                ),
            },
            {
                field: "createdDateTime",
                headerName: t("Created On"),
                type: "dateTime",
                width: 180,
                valueGetter: (_, row) => {
                    return `${row.createdDateTime || ''}`;
                },

                // ✅ Format the Date object safely
                valueFormatter: formatDate,

                renderCell: (params) => {
                    if (!params.value || typeof params.value !== "string") return "";

                    // Add 'Z' if missing to force UTC interpretation
                    const isoString = params.value.endsWith("Z") ? params.value : `${params.value}Z`;
                    const date = new Date(isoString);
                    if (isNaN(date.getTime())) return "";

                    const dateLocal = new Intl.DateTimeFormat(undefined, {
                        dateStyle: "medium",
                        timeStyle: "short",
                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    }).format(date);

                    return dateLocal;
                }

            },
            //{
            //    field: "customsReferenceNumber",
            //    headerName: t("Customs Reference"),
            //    width: 150,
            //    valueGetter: (_value, row: { orderDetails?: { customsReferenceNumber?: string }[] }) => {
            //        const orderDetails = row.orderDetails;
            //        if (!Array.isArray(orderDetails) || orderDetails.length === 0) return "";
            //        return orderDetails[0]?.customsReferenceNumber || "";
            //    },
            //},
            {
                field: "customsReferenceNumber",
                headerName: t("Customs Reference"),
                width: 180,
                valueGetter: (_value, row: Order) => {
                    return row.orderDetails?.[0]?.customsReferenceNumber ?? "";
                },
                sortComparator: (v1, v2) => {
                    const a = (v1 ?? "").toString();
                    const b = (v2 ?? "").toString();
                    return a.localeCompare(b);
                },
                renderCell: (params: GridRenderCellParams) => {
                    const value = params.row.orderDetails?.[0]?.customsReferenceNumber ?? "";
                    return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <span>{value}</span>
                            {value && (
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation(); // prevent row navigation
                                        copyToClipboard(value);
                                    }}
                                >
                                    <ContentCopyIcon fontSize="small" />
                                </IconButton>
                            )}
                        </Box>
                    );
                },
            },

            {
                field: "assignedToUserId", headerName: t("Assigned To"), width: 100, valueGetter: (params) => {
                    //console.log("Search users:", users);
                    //const userId = params as string;
                    const userForOrder = users.find(u => u.id === params);
                    return userForOrder ? userForOrder.userName : '';
                },
            },
            { field: "initialEmailSubject", headerName: t("Initial Email Subject"), width: 100 },
            { field: "initialEmailSubjectShorten", headerName: "Shorten Email Subject", width: 100 },
            {
                field: "customerId", headerName: t("Customer"), width: 100, valueGetter: (params) => {
                    const customer = customers.find(u => u.id === params);
                    return customer ? customer.name : '';
                }
            },
            //{
            //    field: "declarantCustomerId", headerName: t("Declarant"), width: 100, valueGetter: (params) => {
            //        const customer = customers.find(u => u.id === params);
            //        return customer ? customer.name : '';
            //    }
            //},
            {
                field: "stateId", headerName: t("State"), width: 100, valueGetter: (params) => {
                    const orderState = orderStates.find(u => u.id === params);
                    return orderState ? orderState.name : '';
                }
            },
          
            //{
            //    field: "orderTypeId", headerName: t("Type"), width: 100, valueGetter: (params) => {
            //        const orderType = orderTypes.find(u => u.id === params);
            //        return orderType ? orderType.name : '';
            //    }
            //},
            //{
            //    field: "services",
            //    headerName: t("Services"),
            //    width: 200,
            //    renderCell: (params: GridRenderCellParams) => {
            //        const orderServices: OrderService[] = params.row.orderServices ?? []; // ✅ Extract `OrderServices`

            //        // ✅ Extract service IDs from OrderServices
            //        const serviceIds = orderServices.map(os => os.serviceId);

            //        // ✅ Match service names based on extracted IDs
            //        const serviceNames = services
            //            .filter(service => serviceIds.includes(service.id ?? ""))
            //            .map(service => service.name)
            //            .join(", ");

            //        return <span>{serviceNames || t("No services")}</span>;
            //    }
            //},
            //{
            //    field: "dueDate", headerName: t("Due Date"), width: 100, type: 'date',
            //    valueFormatter: (params) => {
            //        if (params == null) {
            //            return "";
            //        }
            //        else {
            //            const { year, month, day } = params;
            //            const date = new Date(year, month - 1, day);
            //            return new Intl.DateTimeFormat(locale, {
            //                dateStyle: 'short',
            //            }).format(date);
            //            return "";
            //        }

            //    }
            //},
            {
                field: "prePaid", headerName: t("Pre Paid"), width: 100,
                valueFormatter: (params) => {
                    if (params == null) {
                        return t("no");
                    }
                    else {
                        if (params == true) { return t("yes"); }
                        else { return t("no"); }
                    }
                }
            },
            {
                field: "invoiced", headerName: t("Invoiced"), width: 100,
                valueFormatter: (params) => {
                    if (params == null) {
                        return t("no");
                    }
                    else {
                        if (params == true) { return t("yes"); }
                        else { return t("no"); }
                    }
                }
            },
            {
                field: "paid", headerName: t("Paid"), width: 100,
                valueFormatter: (params) => {
                    if (params == null) {
                        return t("no");
                    }
                    else {
                        if (params == true) { return t("yes"); }
                        else { return t("no"); }
                    }
                }
            },
            //{
            //    field: "invoiceNumber", headerName: t("Invoice Number"), width: 100, editable: false,
            //},
            {
                field: "priority",
                headerName: t("Priority"),
                flex: 1,
                editable: true,
                type: "singleSelect",
                valueOptions: ORDER_PRIORITIES.map(p => ({ value: p, label: t(p) })),
                sortComparator: (a, b) =>
                    PRIORITY_ORDER[a as OrderPriority] - PRIORITY_ORDER[b as OrderPriority],
                valueFormatter: formatPriority, // <-- v7: gets the value directly
            },
        
            {
                field: "notes", headerName: t("Notes"), width: 100, editable: false,
            },
            /*{ field: "missingInfo", headerName: t("Missing Info"), width: 100, editable: false},*/
            //{
            //    field: "documentStored", headerName: t("Documents Stored"), width: 100,
            //    valueFormatter: (params) => {
            //        if (params == null) {
            //            return t("no");
            //        }
            //        else {
            //            if (params == true) { return t("yes"); }
            //            else { return t("no"); }
            //        }
            //    }
            //},

        ];
    } , [t, locale, users, customers, orderStates, services]);

    const [columns, setColumns] = useState<GridColDef[]>(() => {
        // On initial load, you could parse localStorage here if you wish
        return baseColumns;
    });
    //const [error, setError] = useState(false); // Validation error state

    const savedSortKey = "sortOrdersList";
    const savedFilterKey = "filterOrdersList";
    const savedColumnsOrderKey = 'columnOrdersList';
    const didInit = useRef(false);
    const connectionRef = useRef<signalR.HubConnection | null>(null);
    const [viewers, setViewers] = useState<string[]>([]);
    const { enqueueSnackbar } = useSnackbar();

    const currentUserId = localStorage.getItem("userId");

    const user = useMemo(() => {
        if (!currentUserId) return null;
        return users.find(u => u.id === currentUserId) || null;
    }, [currentUserId, users]);

    /*const fetchOrders = useCallback(async () => {
        setLoading((prev) => ({ ...prev, global: true }));

        try {
            const sortField = sortModel.length > 0 ? sortModel[0].field : "Id";
            const sortOrder = sortModel.length > 0 ? sortModel[0].sort : "asc";
            //const filterItem: GridFilterItem = filterModel.items.length > 0 ? filterModel.items[0] : {};
            //const filterField = filterItem.columnField || "";
            //const filterValue = filterItem.value || "";

            // Extract multiple filters
            const filterFields = filterModel.items.map(f => f.field);
            const filterValues = filterModel.items.map(f => f.value);
            const filterOperations = filterModel.items.map(f => f.operator);

            const token = localStorage.getItem("token");
            //console.log("Sorting by:", sortField);
            const response = await axiosExt.get(`${API_BASE_URL}/orders?`, {
                params: {
                    page,
                    pageSize,
                    sortField,
                    sortOrder,
                    filterFields,
                    filterOperations,
                    filterValues,
                },
                paramsSerializer: params => new URLSearchParams(params).toString(),
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            //setOrders(response.data.data);
            setOrders((response.data.data as Order[]).map((order: Order) => ({
                ...order,
                id: order.id ?? `temp-${order.internalNumber || crypto.randomUUID()}`
            })));
            setTotalRows(response.data.totalRecords);

        } catch (error) {
            console.error("Error fetching orders:", error);
        } finally {
            setLoading((prev) => ({ ...prev, global: false }));
        }

    }, [page, pageSize, sortModel, filterModel]);  // Dependencies to prevent infinite loop
    */

    useEffect(() => {
        setPage(0);
    }, [orders]);

    /*useEffect(() => {
        // Whenever baseColumns changes (like after 'users' updates),
        // we merge the *ordering* in `columns` with the *callbacks* in `baseColumns`.
        setColumns(prevColumns => {
            // 1) Build a map from field -> new base column
            const baseMap = new Map(baseColumns.map(col => [col.field, col]));

            // 2) Rebuild an array preserving user’s *order* from `prevColumns`,
            //    but injecting the updated definitions from baseColumns.
            const merged = prevColumns.map(oldCol => {
                // If baseColumns still has that field, use the updated column
                if (baseMap.has(oldCol.field)) {
                    const updatedCol = baseMap.get(oldCol.field)!;
                    baseMap.delete(oldCol.field); // So we don't reuse it
                    return { ...updatedCol, width: oldCol.width };
                }
                // else, it might have been removed from baseColumns – skip or keep oldCol
                return oldCol;
            });

            // 3) If there are any new columns in baseColumns that
            //    didn't exist before, add them at the end
            for (const leftover of baseMap.values()) {
                merged.push(leftover);
            }

            return merged;
        });
    }, [baseColumns]);*/

    useEffect(() => {
        const savedOrderStr = localStorage.getItem("myColumnOrderKey");
        const savedWidthsStr = localStorage.getItem("orderTableColumnWidths");

        const savedOrder: string[] = savedOrderStr ? JSON.parse(savedOrderStr) : [];
        const savedWidths: Record<string, number> = savedWidthsStr ? JSON.parse(savedWidthsStr) : {};

        const baseMap = new Map(baseColumns.map(col => [col.field, col]));

        const orderedCols: GridColDef[] = savedOrder
            .map(field => {
                const col = baseMap.get(field);
                if (!col) return null;
                baseMap.delete(field);
                return { ...col, width: savedWidths[field] ?? col.width };
            })
            .filter(Boolean) as GridColDef[];

        const remainingCols = Array.from(baseMap.values());

        setColumns([...orderedCols, ...remainingCols]);
    }, [baseColumns]);


    useEffect(() => {
        //setLoading((prev) => ({ ...prev, global: true }));

        const isFirstLoad = prevPage.current === null;
        if (didInit.current) return;
        didInit.current = true;

        const savedSortModel = JSON.parse(localStorage.getItem(savedSortKey) ?? "[]");
        const savedFilterModel = (() => {
            try {
                const parsed = JSON.parse(localStorage.getItem(savedFilterKey) ?? "{}");
                return parsed && parsed.items ? parsed : { items: [] };
            } catch (error) {
                console.error("Error parsing savedFilterKey:", error);
                return { items: [] }; // Fallback
            }
        })();

        setSortModel(savedSortModel);
        setFilterModel(savedFilterModel);

        const savedColumnOrder = localStorage.getItem(savedColumnsOrderKey);
        if (savedColumnOrder) {
            try {
                const orderedFields = JSON.parse(savedColumnOrder);
                if (Array.isArray(orderedFields)) {
                    const reorderedColumns = orderedFields
                        .map((field) => columns.find((col) => col.field === field))
                        .filter((col): col is GridColDef => col !== undefined);
                    setColumns(reorderedColumns);
                }
            } catch (e) {
                console.error('Error parsing stored column order:', e);
            }
        }

        if (!connectionRef.current) {
            connectionRef.current = new signalR.HubConnectionBuilder()
                .withUrl(`${API_BASE_URL}/orderHub`, {
                    transport: HttpTransportType.WebSockets, // ✅ Force WebSockets to avoid negotiation issues
                    withCredentials: true // ✅ Required if using authentication
                })
                .configureLogging(LogLevel.Debug)
                .withAutomaticReconnect()
                .build();
        }

        /*const connection = connectionRef.current;

        // Start the connection
        async function startConnection() {
            if (connection.state === signalR.HubConnectionState.Connected || connection.state === signalR.HubConnectionState.Connecting) {
                //console.log("SignalR already connected or connecting...");
                return;
            }

            try {
                await connection.start();
                //console.log("Connected to SignalR Hub");
            } catch (err) {
                console.error("Error connecting to SignalR:", err);
                //console.error(API_BASE_URL);
                setTimeout(startConnection, 5000); // Retry connection if it fails
            }
        }

        startConnection();

        // Listen for new order creation
        connection.on("NewOrderCreated", (newOrderId) => {
            console.log("New order created:", newOrderId);
            //fetchOrders(); // Refresh orders without refreshing page
        });*/

        // Listen for order updates
        /*connection.on("OrderHasNewEmail", (updatedOrderId) => {
            //console.log("Order has new email:", updatedOrderId);
            
        });*/

        //setLocale('de');
        //console.log("Available locales:", locales);

        const storedLang = localStorage.getItem("language") as LocaleKey | null;
        const lang = storedLang && locales.includes(storedLang) ? storedLang : "en";

        setLocale(lang);
              

        if (
            isFirstLoad ||
            prevPage.current !== page ||
            prevPageSize.current !== pageSize ||
            JSON.stringify(prevSortModel.current) !== JSON.stringify(sortModel) ||
            JSON.stringify(prevFilterModel.current) !== JSON.stringify(filterModel)
        ) {
            //fetchUsers();
            //fetchServices();
            //fetchOrderTypes();
            //fetchOrderStates();
            //fetchCustomers();
            //fetchOrders();
            //fetchOrders();
            // **Update Ref Values**
            prevPage.current = page;
            prevPageSize.current = pageSize;
            prevSortModel.current = sortModel;
            prevFilterModel.current = filterModel;
        }

        setLoading((prev) => ({ ...prev, global: false}));

    }, []);
    //        , [customerId]);

    /*useEffect(() => {
        fetchOrders();
    }, [fetchOrders]); // ✅ Using useCallback function*/

    useEffect(() => {
        setSelectionModel([]); // Clear previous selection
    }, [orders]); // 


    useEffect(() => {
        console.log("users changed ->", users);
    }, [users]);

    useEffect(() => {
        if (!connectionRef.current) {
            connectionRef.current = new signalR.HubConnectionBuilder()
                .withUrl(`${API_BASE_URL}/orderHub`, {
                    transport: HttpTransportType.WebSockets,
                    withCredentials: true,
                })
                .configureLogging(LogLevel.Information)
                .withAutomaticReconnect()
                .build();
        }

        const connection = connectionRef.current;

        async function startConnection() {
            if (connection.state === signalR.HubConnectionState.Disconnected) {
                await connection.start();
            }
        }

        startConnection();

        connection.on("OrderViewersUpdated", (orderId: string, userList: string[]) => {
            if (selectedOrder && orderId === selectedOrder.id) {
                setViewers(userList);
            }
        });

        return () => {
            if (connection.state === signalR.HubConnectionState.Connected && selectedOrder && user) {
                connection.invoke("LeaveOrder", selectedOrder.id, user.userName).catch(console.error);
            }
        };
    }, [selectedOrder?.id]);

    useEffect(() => {
        if (!user) return;

        if (viewers.length > 1) {
            const others = viewers.filter(v => v !== user.userName);
            enqueueSnackbar(
                others.length > 0
                    ? `${t("Warning")}: ${others.join(", ")} ${t("is also viewing this order. Your changes may overwrite theirs.")}`
                    : `${t("Warning")}: ${viewers.join(", ")} ${t("are viewing this order. Your changes may overwrite theirs.")}`,
                { variant: "warning", autoHideDuration: 6000 }
            );
        }
    }, [viewers, user?.userName]);

    /*useEffect(() => {
        const savedColumnOrderStr = localStorage.getItem("myColumnOrderKey");
        if (!savedColumnOrderStr) return;

        try {
            const savedOrder = JSON.parse(savedColumnOrderStr) as string[];
            setColumns(prev => {
                // Rebuild array in that order
                const newCols: GridColDef[] = [];
                for (const field of savedOrder) {
                    const found = prev.find(col => col.field === field);
                    if (found) newCols.push(found);
                }
                // Add any columns that weren't in local storage
                for (const col of prev) {
                    if (!newCols.includes(col)) {
                        newCols.push(col);
                    }
                }
                return newCols;
            });
        } catch (err) {
            console.error("Error parsing column order:", err);
        }
    }, []);*/

    useEffect(() => {
        const savedColumnOrderStr = localStorage.getItem("myColumnOrderKey");
        const savedWidthsStr = localStorage.getItem("orderTableColumnWidths");

        if (!savedColumnOrderStr) return;

        try {
            const savedOrder: string[] = JSON.parse(savedColumnOrderStr);
            const savedWidths: Record<string, number> = savedWidthsStr ? JSON.parse(savedWidthsStr) : {};

            setColumns((prevColumns) => {
                // Create a map of current columns for reliable lookup
                const colMap = new Map(prevColumns.map((col) => [col.field, col]));

                // Build columns in saved order with widths
                const tempColumns = savedOrder
                    .map((field) => {
                        const col = colMap.get(field);
                        return col ? { ...col, width: savedWidths[field] ?? col.width } : undefined;
                    })
                    .filter(Boolean); // Still inferred as (GridColDef | undefined)[]

                const reorderedColumns: GridColDef[] = tempColumns as GridColDef[];

                // Append any columns not saved
                const remaining = prevColumns.filter((col) => !savedOrder.includes(col.field));
                return [...reorderedColumns, ...remaining];
            });
        } catch (error) {
            console.error("Error restoring column order or widths:", error);
        }
        finally {
            setLoading((prev) => ({ ...prev, global: false }));
        }
    }, []);



    // Generate dynamic `sx` styles for each orderState
    /*const dynamicSx = orderStates.reduce((styles, state) => {
        styles[`& .row-state-${state.id}`] = {
            backgroundColor: state.bgColorRGB,
            color: state.colorRGB,
        };
        return styles;
    }, {});*/
    const dynamicSx: Record<string, { backgroundColor: string; color: string; }> =
        orderStates.reduce((styles, state) => {
            styles[`& .row-state-${state.id}`] = {
                backgroundColor: state.bgColorRGB,
                color: state.colorRGB,
            };
            return styles;
        }, {} as Record<string, { backgroundColor: string; color: string; }>);


    /*const getCreatedDateTime: GridValueGetter<{ createdDateTime?: string | Date | null }> = (_, row) => {
        return row.createdDateTime ? new Date(row.createdDateTime) : null;
    };*/

    // Save sortModel changes to localStorage
    const handleSortModelChange = (newModel: GridSortModel) => {
        setSortModel(newModel);
        localStorage.setItem(savedSortKey, JSON.stringify(newModel));
    };

    // Save filterModel changes to localStorage with Date Formatting
    const handleFilterModelChange = (newModel: GridFilterModel) => {
        const formattedModel = {
            ...newModel,
            items: newModel.items.map((filter) => {
                if ((filter.field === "dueDate") && filter.value) {
                    return {
                        ...filter,
                        value: new Date(filter.value as string).toISOString().split("T")[0], // Convert to YYYY-MM-DD
                    };
                }
                if ((filter.field === "createdDateTime") && filter.value) {
                    const date = new Date(filter.value as string);

                    // ✅ Preserve Local Time Instead of UTC
                    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;

                    return {
                        ...filter,
                        value: formattedDate, // ✅ Correct local date-time format (YYYY-MM-DD HH:mm:ss)
                    };
                }
                return filter;
            }),
        };

        setFilterModel(formattedModel);
        localStorage.setItem(savedFilterKey, JSON.stringify(formattedModel));
    };

    // Handle column order change
    const handleColumnOrderChange = useCallback((params: GridColumnOrderChangeParams) => {
        const { column, targetIndex } = params;

        setColumns(oldCols => {
            const newCols = [...oldCols];
            const oldIndex = newCols.findIndex((c) => c.field === column.field);
            if (oldIndex === -1) return newCols;

            // Reorder them in place
            const [moved] = newCols.splice(oldIndex, 1);
            newCols.splice(targetIndex, 0, moved);

            // Save to local storage
            const fieldsInNewOrder = newCols.map(c => c.field);
            localStorage.setItem("myColumnOrderKey", JSON.stringify(fieldsInNewOrder));

            return newCols;
        });
    }, []);

    const handleColumnVisibilityModelChange = (model: GridColumnVisibilityModel) => {
        setColumnVisibilityModel(model);
        localStorage.setItem(hiddenColsKey, JSON.stringify(model));
    };


    const handleEdit = (order: Order) => {
        //setError(false); // Reset validation state
        setSelectedOrder(order);
        setOpen(true);

        if (connectionRef.current && user) {
            connectionRef.current
                .invoke("JoinOrder", order.id, user.userName)
                .catch(console.error);
        }
    };

    /*const handleDelete = async (id: string) => {
        const token = localStorage.getItem("token");

        try {
            await axiosExt.delete(`${API_BASE_URL}/orders/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setOrders(orders.filter((c) => c.id !== id));
        } catch (error) {
            console.error("Error deleting order:", error);
        }
    };*/

    const handleDelete = async (id: string) => {
        try {
            setItemToDelete(id);
            setConfirmDeleteOpen(true);

        } catch (error) {
            console.error("Error deleting item:", error);
        }
    };

    //const handleConfirmDelete = async () => {
    //    if (itemToDelete === null) return;
    //    const token = localStorage.getItem("token");

    //    try {
    //        await axiosExt.delete(`${API_BASE_URL}/orders/${itemToDelete}`, {
    //            headers: {
    //                Authorization: `Bearer ${token}`,
    //            },
    //        });

    //        onDeleteOrder(itemToDelete);
    //    } catch (error) {
    //        console.error("Error deleting:", error);
    //    } finally {
    //        setConfirmDeleteOpen(false);
    //        setItemToDelete(null);
    //    }
    //};

    const handleConfirmDelete = async () => {
        const token = localStorage.getItem("token");

        try {
            if (itemToDelete) {
                // Delete only one order
                await axiosExt.delete(`${API_BASE_URL}/orders/${itemToDelete}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                // Notify parent or refresh logic if needed
                onDeleteOrder(itemToDelete.toString());
            }
            else {
                const deletePromises = selectionModel.map((id) =>
                    axiosExt.delete(`${API_BASE_URL}/orders/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                );
                await Promise.all(deletePromises);

                // Notify parent or refresh logic if needed
                selectionModel.forEach(id => onDeleteOrder(id.toString()));

            }
                    } catch (error) {
            console.error("Error deleting selected orders:", error);
        } finally {
            setConfirmDeleteOpen(false);
            setSelectionModel([]);
        }
    };


    const handleCancelDelete = () => {
        setConfirmDeleteOpen(false);
        setItemToDelete(null);
        console.log(itemToDelete);
    };


    const handleSave = async () => {
        if (selectedOrder) {
            try {
                
                const payload: Order = {
                    id: selectedOrder.id,

                    customerId: selectedOrder.customerId,
                    declarantCustomerId: selectedOrder.declarantCustomerId,
                    internalNumber: selectedOrder.internalNumber ?? null,
                    createdDateTime: selectedOrder.createdDateTime
                        ? new Date(selectedOrder.createdDateTime)
                        : new Date(),
                    assignedToUserId: selectedOrder.assignedToUserId ?? null,
                    stateId: selectedOrder.stateId || null,
                    orderTypeId: selectedOrder.orderTypeId || null,
                    mergedToOrderId: selectedOrder.mergedToOrderId ?? null,

                    hasUnreadEmails: selectedOrder.hasUnreadEmails ?? false,
                    lastEmailReceivedAt: selectedOrder.lastEmailReceivedAt
                        ? new Date(selectedOrder.lastEmailReceivedAt)
                        : null,
                    dueDate: selectedOrder.dueDate ?? null,
                    prePaid: selectedOrder.prePaid ?? false,
                    invoiced: selectedOrder.invoiced ?? false,
                    invoiceNumber: selectedOrder.invoiceNumber ?? null,
                    paid: selectedOrder.paid ?? false,

                    initialEmailSubject: selectedOrder.initialEmailSubject ?? null,
                    initialEmailSubjectShorten: selectedOrder.initialEmailSubjectShorten ?? null,
                    notes: selectedOrder.notes ?? null,
                    missingInfo: selectedOrder.missingInfo ?? null,
                    priority:selectedOrder.priority??null,

                    documentStored: selectedOrder.documentStored ?? false,
                    emailConversations: selectedOrder.emailConversations ?? [],
                    serviceIds: null, // always null, handled via orderServices
                    unreadEmailsNumber:selectedOrder.unreadEmailsNumber,
                    orderServices: (selectedOrder.orderServices ?? []).map(os => ({
                        serviceId: os.serviceId,
                        orderId: selectedOrder.id || "",
                        quantity: os.quantity,
                        isCompleted: os.isCompleted,
                        additionalUnits: os.additionalUnits,
                        customPrice: os.customPrice,
                        assignedUserId:os.assignedUserId
                    })),
                    orderDetails: selectedOrder.orderDetails ?? [],
                };


                await onSaveOrder(payload); 
                //await onSaveOrder(sanitizeOrderPayload(selectedOrder));
                setOpen(false);
                setSelectedOrder(null);
            } catch (error) {
                console.error("Error saving order:", error);
            }
        }
    };

    
    // Move to the next row when Enter is pressed
    const handleEditStop = (params: GridCellEditStopParams) => {
        if (params.reason === GridCellEditStopReasons.enterKeyDown) {
            //setEditableRow((prev) => (prev + 1 < orders.length ? prev + 1 : prev));
        }
    };

    const handleClose = () => {

        if (connectionRef.current && selectedOrder && user) {
            connectionRef.current
                .invoke("LeaveOrder", selectedOrder.id, user.userName)
                .catch(console.error);
        }

        setOpen(false);
        setSelectedOrder(null);
    };

    const createServiceInvoices = async () => {
        const token = localStorage.getItem("token");

        try {
            if (!selectionModel || selectionModel.length === 0) {
                enqueueSnackbar("Please select at least one order.", { variant: "warning" });
                return;
            }

            const orderIds = selectionModel.map(id => String(id));

            const response = await axiosExt.post(
                `${API_BASE_URL}/orders/create-service-draft-multiple-orders`,
                { orderIds },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            enqueueSnackbar("Combined service invoice draft created successfully.", {
                variant: "success",
            });

            console.log("Invoice result", response.data);

            
        } catch (error) {
            console.error("Error generating service invoice selected orders:", error);
            let message = "Failed to create combined service invoice draft.";

            if (axios.isAxiosError(error)) {
                message =
                    error.response?.data?.message ??
                    (typeof error.response?.data === "string"
                        ? error.response.data
                        : error.message);
            } else if (error instanceof Error) {
                message = error.message;
            }

            enqueueSnackbar(message, { variant: "error" });
        } finally {
            setConfirmDeleteOpen(false);
            setSelectionModel([]);
        }
    }


    //const createTaxInvoices = async () => {
    //    const token = localStorage.getItem("token");

    //    try {
    //        if (!selectionModel || selectionModel.length === 0) {
    //            enqueueSnackbar("Please select at least one order.", { variant: "warning" });
    //            return;
    //        }

    //        const orderIds = selectionModel.map(id => String(id));

    //        const response = await axiosExt.post(
    //            `${API_BASE_URL}/orders/create-tax-draft-multiple-orders`,
    //            { orderIds },
    //            {
    //                headers: {
    //                    Authorization: `Bearer ${token}`,
    //                },
    //            }
    //        );

    //        enqueueSnackbar("Combined tax invoice draft created successfully.", {
    //            variant: "success",
    //        });

    //        console.log("Invoice result", response.data);


    //    } catch (error) {
    //        console.error("Error generating tax invoice selected orders:", error);
    //    } finally {
    //        setConfirmDeleteOpen(false);
    //        setSelectionModel([]);
    //    }
    //}
    

    return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
        <Box style={{ width: "100%"}} >
           <Box style={{ width: "100%", display: "flex", marginTop: "0px" }}>
                    <Typography variant="h4">{t("Orders")}</Typography>
               
                < Button
                    variant = "contained"
                    color = "primary"
                    onClick = {() => {
                        setSelectedOrder({
                            id: "",
                            internalNumber: null,
                            customerId: "",
                            declarantCustomerId: null,
                            assignedToUserId: null,
                            stateId: null,
                            priority:"Medium",
                            orderTypeId: null,
                            dueDate: null,
                            prePaid:false,
                            invoiced:false,
                            invoiceNumber: "",
                            paid:false,
                            notes: "",
                            missingInfo: "",
                            createdDateTime:new Date(),
                            serviceIds:null,
                            documentStored: false,
                            initialEmailSubject: null,
                            initialEmailSubjectShorten: null,
                            emailConversations: null,
                            orderServices: null,
                            orderDetails: null,
                            hasUnreadEmails: false,
                            unreadEmailsNumber: 0,
                            lastEmailReceivedAt: null,
                            mergedToOrderId: null,
                        });
                        setOpen(true);
                    }}
                    style = {{ marginBottom: "0px", marginTop: "0px", marginLeft:"10px"}}
                                    >
                    {t("Add")}
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        disabled={selectionModel.length === 0}
                        onClick={() => createServiceInvoices()}
                        style={{ marginLeft: "10px" }}
                    >
                        {t("Service Invoice Draft")}
                    </Button>

                    {/*<Button*/}
                    {/*    variant="contained"*/}
                    {/*    color="primary"*/}
                    {/*    disabled={selectionModel.length === 0}*/}
                    {/*    onClick={() => createTaxInvoices()}*/}
                    {/*    style={{ marginLeft: "10px" }}*/}
                    {/*>*/}
                    {/*    {t("Tax Invoice")}*/}
                    {/*</Button>*/}

                    <Button
                        variant="contained"
                        color="error"
                        disabled={selectionModel.length === 0}
                        onClick={() => setConfirmDeleteOpen(true)}
                        style={{ marginLeft: "10px" }}
                    >
                        {t("Delete Selected")}
                    </Button>
                </Box>
                {loading.global ? (
                    <Box>{t("Loading...")}</Box>
                ) : (
                        <Box
                            sx={{
                                height: "100%",
                                width: "100%",
                                mt: 2,          // optional vertical spacing
                                mr: 2,          // match with right margin to keep centered look
                                overflow: "auto", // enables scroll if needed
                            }}
                        >
                            <Box
                                sx={{
                                    height: "calc(100vh - 140px)", // Adjust this based on header height, margins, etc.
                                    overflow: "auto",
                                }}
                            >
                            <DataGridPro
                                    rows={orders.map(order => ({
                                        ...order,
                                        priority: ORDER_PRIORITIES.includes(order.priority as OrderPriority)
                                            ? (order.priority as OrderPriority)
                                            : "Medium",
                                        id: order.id ?? `temp-${order.internalNumber || crypto.randomUUID()}`
                                    }))}
                                    columns={columns}
                                    localeText={localeMap[locale] || enUS.components.MuiDataGrid.defaultProps.localeText}
                                    sortModel={sortModel}
                                onColumnWidthChange={handleColumnResize}
                                onSortModelChange={handleSortModelChange}
                                filterModel={filterModel}
                                onFilterModelChange={handleFilterModelChange}
                                disableColumnReorder={false}
                                rowSelectionModel={selectionModel}
                                onRowSelectionModelChange={(newSelection) => setSelectionModel([...newSelection])}
                                columnVisibilityModel={columnVisibilityModel}
                                onColumnVisibilityModelChange={handleColumnVisibilityModelChange}
                                pagination
                                checkboxSelection
                                //paginationMode="server"
                                //sortingMode="server"
                                //filterMode="server"
                                    onColumnOrderChange={handleColumnOrderChange}
                                    paginationModel={{ page, pageSize }}   
                                onPaginationModelChange={(model: GridPaginationModel) => {
                                    setPage(model.page);
                                    setPageSize(model.pageSize);
                                    localStorage.setItem(pageSizeKey, model.pageSize.toString());
                                    }}
                                    onRowClick={(params, event) => {
                                        const isButtonClick = (event.target as HTMLElement).closest('button');
                                        if (isButtonClick) return;

                                        navigate(`/orderdetailspage/${params.row.id}`);
                                    }}
                                onCellEditStop={handleEditStop}
                                pageSizeOptions={[10,25,50,100]}

                                loading={Object.values(loading).some(Boolean)}
                                getRowId={(row: Order) => {
                                    if (!row.id) {
                                        console.warn("Row missing ID! Generating fallback ID.");
                                    }
                                    return row.id || `temp-${row.internalNumber || crypto.randomUUID()}`;
                                }}
                                getRowClassName={(params: GridRowParams<Order>) => `row-state-${params.row.stateId}`}
                                sx={{
                                    ...dynamicSx, // Apply the dynamically generated styles
                                    height: "100%",
                                    width: "100%",
                                    '& .MuiDataGrid-virtualScroller': {
                                        overflowX: "hidden",
                                    },
                                    // Base row styling: no alternating background
                                    "& .MuiDataGrid-row": {
                                        backgroundColor: "#ffffff !important",
                                        borderBottom: "1px solid #E1E1E1 !important", // darker gray separator
                                    },

                                    // Apply persistent and hover state colors with !important
                                    ...Object.fromEntries(
                                        orderStates.flatMap((state) => [
                                            [
                                                `& .MuiDataGrid-row.row-state-${state.id}`,
                                                {
                                                    backgroundColor: `${state.bgColorRGB} !important`,
                                                    color: `${state.colorRGB} !important`,
                                                },
                                            ],
                                            [
                                                `& .MuiDataGrid-row.row-state-${state.id}:hover`,
                                                {
                                                    filter: "brightness(0.93) !important",
                                                },
                                            ],
                                            [
                                                `& .MuiDataGrid-row.row-state-${state.id}.Mui-selected`,
                                                {
                                                    backgroundColor: `${state.bgColorRGB} !important`,
                                                    filter: "brightness(0.9) !important", // slightly darker when selected
                                                },
                                            ],
                                        ])
                                    ),
                                }}
                                />
                            </Box>
                    </Box>)}
        < Dialog open = { open } onClose = { handleClose } >
            <DialogTitle>
                    {selectedOrder?.id
                        ? `${t("Edit")} ${t("Order")} # ${selectedOrder.internalNumber || "-"}`
                        : t("Add")
                    }
            </DialogTitle>
            < DialogContent >
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>{t("Initial Email Subject") }: {selectedOrder?.initialEmailSubject}</Typography>
            <TextField
                margin="dense"
                label={t("Initial Email Subject")}
                fullWidth
                value={selectedOrder?.initialEmailSubject || ""}
                onChange={(e) =>
                    setSelectedOrder((prev) =>
                        prev ? { ...prev, initialEmailSubject: e.target.value, initialEmailSubjectShorten:e.target.value } : null
                    )}
            />

            < FormControl fullWidth margin="dense" >
                <Autocomplete
                    options={customers}
                    getOptionLabel={(c) => c?.name || ""}
                    value={customers.find(c => c.id === selectedOrder?.customerId) || null}
                    onChange={(_, newValue) =>
                        setSelectedOrder((prev) =>
                            prev ? { ...prev, customerId: newValue?.id ?? "" } : null
                        )
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("Customer")}
                            margin="dense"
                            fullWidth
                        />
                    )}
                    filterOptions={(options, { inputValue }) =>
                        options.filter((o) =>
                            o.name?.toLowerCase().includes(inputValue.toLowerCase())
                        )
                    }
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                />
            </FormControl>
            {/*< FormControl fullWidth margin="dense" >*/}
            {/*    <InputLabel>{t("Declarant")}</InputLabel>*/}
            {/*    <Autocomplete*/}
            {/*        options={customers}*/}
            {/*        getOptionLabel={(c) => c?.name || ""}*/}
            {/*                    value={customers.find(c => c.id === selectedOrder?.declarantCustomerId) || null}*/}
            {/*        onChange={(_, newValue) =>*/}
            {/*            setSelectedOrder((prev) =>*/}
            {/*                prev ? { ...prev, declarantCustomerId: newValue?.id ?? "" } : null*/}
            {/*            )*/}
            {/*        }*/}
            {/*        renderInput={(params) => (*/}
            {/*            <TextField*/}
            {/*                {...params}*/}
            {/*                label={t("Declarant")}*/}
            {/*                margin="dense"*/}
            {/*                fullWidth*/}
            {/*            />*/}
            {/*        )}*/}
            {/*        filterOptions={(options, { inputValue }) =>*/}
            {/*            options.filter((o) =>*/}
            {/*                o.name?.toLowerCase().includes(inputValue.toLowerCase())*/}
            {/*            )*/}
            {/*        }*/}
            {/*        isOptionEqualToValue={(option, value) => option.id === value.id}*/}
            {/*    />*/}
            {/*</FormControl>*/}
            <FormControl fullWidth margin="dense">
                <InputLabel>{t("Assigned To")}</InputLabel>
                <Select
                    value={selectedOrder?.assignedToUserId || ""}
                    onChange={(e) =>
                        setSelectedOrder((prev) =>
                            prev ? { ...prev, assignedToUserId: e.target.value } : null
                        )
                    }
                >
                    {users.map((user) => (
                        <MenuItem key={user.id} value={user.id}>
                            {user.userName}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth margin="dense">
                <InputLabel>{t("State")}</InputLabel>
                <Select
                    value={selectedOrder?.stateId || ""}
                    onChange={(e) =>
                        setSelectedOrder((prev) =>
                            prev ? { ...prev, stateId: e.target.value } : null
                        )
                    }
                >
                {orderStates
                    .slice()
                    .sort((a, b) => {
                        if (a.sortOrder !== b.sortOrder) {
                            return (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
                        }
                        return a.name.localeCompare(b.name);
                    })
                    .map((orderState) => (
                        <MenuItem key={orderState.id} value={orderState.id || ""}>
                            {orderState.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth margin="dense">
                <InputLabel>{t("Priority")}</InputLabel>
                <Select
                    value={selectedOrder?.priority || "Medium"}
                    onChange={(e) =>
                        setSelectedOrder((prev) =>
                            prev ? { ...prev, priority: e.target.value as OrderPriority } : null
                        )
                    }
                >
                    <MenuItem value="Low">{t("Low")}</MenuItem>
                    <MenuItem value="Medium">{t("Medium")}</MenuItem>
                    <MenuItem value="High">{t("High")}</MenuItem>
                    <MenuItem value="Critical">{t("Critical")}</MenuItem>
                </Select>
            </FormControl>

            {/*<FormControl fullWidth margin="dense">*/}
            {/*            <InputLabel>{t("Type")}</InputLabel>*/}
            {/*    <Select*/}
            {/*        value={selectedOrder?.orderTypeId || ""}*/}
            {/*        onChange={(e) =>*/}
            {/*            setSelectedOrder((prev) =>*/}
            {/*                prev ? { ...prev, orderTypeId: e.target.value } : null*/}
            {/*            )*/}
            {/*        }*/}
            {/*    >*/}
            {/*        {orderTypes.map((orderType) => (*/}
            {/*            <MenuItem key={orderType.id ?? ""} value={orderType.id ?? ""}>*/}
            {/*                {orderType.name}*/}
            {/*            </MenuItem>*/}
            {/*        ))}*/}
            {/*    </Select>*/}
            {/*</FormControl>*/}
            {/*<FormControl fullWidth margin="dense">*/}
            {/*    <InputLabel>{t("Services")}</InputLabel>*/}
            {/*    <Select*/}
            {/*        multiple*/}
            {/*        value={selectedOrder?.orderServices?.map(os => os.serviceId) ?? []}*/}
            {/*        onChange={(e) => {*/}
            {/*            const values = e.target.value as string[];*/}

            {/*            setSelectedOrder((prev) =>*/}
            {/*                prev*/}
            {/*                    ? {*/}
            {/*                        ...prev,*/}
            {/*                        orderServices: values.map(serviceId => {*/}
            {/*                            // Find existing orderService for this serviceId, if any*/}
            {/*                            const existing = prev.orderServices?.find(os => os.serviceId === serviceId);*/}

            {/*                            return {*/}
            {/*                                orderId: prev.id || "",*/}
            {/*                                serviceId,*/}
            {/*                                quantity: existing?.quantity ?? 1, // default 1 if new*/}
            {/*                                assignedUserId: existing?.assignedUserId ?? null,*/}
            {/*                                isCompleted: existing?.isCompleted ?? false,*/}
            {/*                            };*/}
            {/*                        }),*/}
            {/*                    }*/}
            {/*                    : null*/}
            {/*            );*/}
            {/*        }}*/}
            {/*        renderValue={(selected) =>*/}
            {/*            services*/}
            {/*                .filter(s => s.id && (selected as string[]).includes(s.id))*/}
            {/*                .map(s => s.name)*/}
            {/*                .join(", ")*/}
            {/*        }*/}
            {/*    >*/}
            {/*        {services.map((service) => (*/}
            {/*            <MenuItem key={service.id ?? ""} value={service.id ?? ""}>*/}
            {/*                <Checkbox*/}
            {/*                    checked={*/}
            {/*                        selectedOrder?.orderServices?.some(os => os.serviceId === service.id) || false*/}
            {/*                    }*/}
            {/*                />*/}
            {/*                {service.name}*/}
            {/*            </MenuItem>*/}
            {/*        ))}*/}
            {/*    </Select>*/}
            {/*</FormControl>*/}


            {/*<Box>*/}
            {/*    <DatePicker*/}
            {/*        label={t("Due Date")}*/}
            {/*        value={*/}
            {/*            selectedOrder?.dueDate*/}
            {/*                ? dayjs(new Date(selectedOrder.dueDate.year, selectedOrder.dueDate.month - 1, selectedOrder.dueDate.day))*/}
            {/*                : null*/}
            {/*        }*/}
            {/*        onChange={(date) => {*/}
            {/*            if (date) {*/}
            {/*                setSelectedOrder((prev) => {*/}
            {/*                    return prev*/}
            {/*                        ? {*/}
            {/*                            ...prev,*/}
            {/*                            dueDate: {*/}
            {/*                                year: date.year(),*/}
            {/*                                month: date.month()+ 1,*/}
            {/*                                day: date.date(),*/}
            {/*                                dayOfWeek: date.day(),*/}
            {/*                            },*/}
            {/*                        }*/}
            {/*                        : null;*/}
            {/*                });*/}
            {/*            } else {*/}
            {/*                setSelectedOrder((prev) => {*/}
            {/*                    return prev ? { ...prev, dueDate: null } : null;*/}
            {/*                });*/}
            {/*            }*/}
            {/*        }}*/}

            {/*    />*/}
            {/*</Box>*/}

            <FormControlLabel
                        control={
                            <Checkbox
                                checked={selectedOrder?.prePaid || false}
                                onChange={(e) =>
                                    setSelectedOrder((prev) =>
                                        prev ? { ...prev, prePaid: e.target.checked } : null
                                    )}
                                color="primary"
                            />
                        }
                        label={t("Pre Paid")}
            />
            <FormControlLabel
                        control={
                            <Checkbox
                                checked={selectedOrder?.invoiced || false}
                                onChange={(e) =>
                                    setSelectedOrder((prev) =>
                                        prev ? { ...prev, invoiced: e.target.checked } : null
                                    )}
                                color="primary"
                            />
                        }
                        label={t("Invoiced")}
            />
            <FormControlLabel
                        control={
                            <Checkbox
                                checked={selectedOrder?.paid || false}
                                onChange={(e) =>
                                    setSelectedOrder((prev) =>
                                        prev ? { ...prev, paid: e.target.checked } : null
                                    )}
                                color="primary"
                            />
                        }
                        label={t("Paid")}
                        />
            {/*<TextField*/}
            {/*                margin="dense"*/}
            {/*                label={t("Invoice Number")}*/}
            {/*                fullWidth*/}
            {/*                value={selectedOrder?.invoiceNumber || ""}*/}
            {/*                onChange={(e) =>*/}
            {/*                    setSelectedOrder((prev) =>*/}
            {/*                        prev ? { ...prev, invoiceNumber: e.target.value } : null*/}
            {/*                    )}*/}
            {/*            />*/}
            <TextField
                margin="dense"
                        label={t("Notes")}
                fullWidth
                value={selectedOrder?.notes || ""}
                onChange={(e) =>
                    setSelectedOrder((prev) =>
                        prev ? { ...prev, notes: e.target.value } : null
                    )}
                />
            {/*<FormControlLabel*/}
            {/*            control={*/}
            {/*                <Checkbox*/}
            {/*                    checked={selectedOrder?.documentStored || false}*/}
            {/*                    onChange={(e) =>*/}
            {/*                        setSelectedOrder((prev) =>*/}
            {/*                            prev ? { ...prev, documentStored: e.target.checked } : null*/}
            {/*                        )}*/}
            {/*                    color="primary"*/}
            {/*                />*/}
            {/*            }*/}
            {/*            label={t("Documents Stored")}*/}
            {/*/>*/}
            {/*<TextField*/}
            {/*    margin="dense"*/}
            {/*            label={t("Missing Info")}*/}
            {/*    fullWidth*/}
            {/*    value={selectedOrder?.missingInfo || ""}*/}
            {/*    onChange={(e) =>*/}
            {/*        setSelectedOrder((prev) =>*/}
            {/*            prev ? { ...prev, missingInfo: e.target.value } : null*/}
            {/*        )}*/}
            {/*/>*/}

        </DialogContent>
        < DialogActions >
            <Button onClick={ handleClose } color = "secondary" >
                        {t("Cancel")}
                </Button>
            < Button onClick = { handleSave } color = "primary" >
                        {t("Save")}
            </Button>
        </DialogActions>
        </Dialog>

        <Dialog open={confirmDeleteOpen} onClose={handleCancelDelete}>
            <DialogTitle>{t("Confirm Deletion")}</DialogTitle>
            <DialogContent>
                {selectionModel.length > 1
                    ? t("Are you sure you want to delete {{count}} records?", { count: selectionModel.length })
                    : t("Are you sure you want to delete this record?")}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancelDelete} color="secondary">{t("no")}</Button>
                <Button onClick={handleConfirmDelete} color="error">{t("yes")}</Button>
            </DialogActions>
        </Dialog>

        <Dialog open={servicesPopupOpen} onClose={handleCloseServicesPopup} maxWidth="sm" fullWidth>
            <DialogTitle>
                {t("Services for Order")}: {popupOrderId}
            </DialogTitle>
            <DialogContent>
                {popupOrderServices.length > 0 ? (
                    <ul>
                        {popupOrderServices.map((os) => {
                            const service = services.find(s => s.id === os.serviceId);
                            return (
                                <li key={os.serviceId}>
                                    {service?.name || t("Unknown Service")} – {t("Qty")}: {os.quantity}
                                </li>
                            );
                        })}
                    </ul>
                ) : (
                    <Typography>{t("No services associated with this order.")}</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseServicesPopup}>{t("Close")}</Button>
            </DialogActions>
        </Dialog>
        </Box>

    </LocalizationProvider>
    );
};

export default OrderTableServerFiltering;